import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <path d="M 12 2.90625 L 4.1875 6.3789062 C 3.4685237 6.698804 3 7.4177833 3 8.2050781 L 3 21 L 7.8320312 21 A 1.0001 1.0001 0 0 0 8.1582031 21 L 15.832031 21 A 1.0001 1.0001 0 0 0 16.158203 21 L 21 21 L 21 20 L 21 8.2050781 C 21 7.4177833 20.531476 6.698804 19.8125 6.3789062 L 19.810547 6.3769531 L 12 2.90625 z M 12 5.09375 L 19 8.2050781 L 19 19 L 17 19 L 17 10 L 7 10 L 7 19 L 5 19 L 5 8.2070312 L 5 8.2050781 L 12 5.09375 z M 9 12 L 15 12 L 15 14 L 14 14 L 14 16 L 15 16 L 15 19 L 9 19 L 9 12 z" />,
  'GarageDoorOutlined'
);
